import {
  SofturaTable,
  PrimaryButton,
  SwitchToggle,
  ModalPopup,
  Label,
  PopupDialogbox,
} from "client/CommonComponents";
import MoreOptions from "client/CommonComponents/MoreOptions";
import EditCategoryModal from "./EditCategoryModal";
import {
  deleteOption,
  editOption,
} from "client/Components/Administraton/utils/constant";
import { useSelector } from "react-redux";
import userManageSelectors from '../../../../../../redux/UserManagement/selectors'

const CategoryManagement = (props: any) => {

  const {
    categoryListData,
    addCategoryVal,
    checkCategory,
    categoryById
  }: any
    = useSelector(
      (state: any) => ({
        categoryListData: userManageSelectors.getCategoryListing(state),
        addCategoryVal: state.UserManagement.addCategory,
        checkCategory: userManageSelectors.checkCategory(state),
        categoryById: state.UserManagement.categoryById
      })
    )

  const option = [editOption, deleteOption];

  const categoryColumns = [
    {
      key: "action",
      title: "Action",
      Cell: (row: any) => {
        return (
          <MoreOptions
            onClick={props.optionHandler}
            options={option}
            {...row.rowData}
           data-attribute="CategoryManagement_Default_MoreOptions" />
        );
      },
      width: 25,
    },
    {
      key: "categoryName",
      title: "Category Name",
      width: 300,
    },
    {
      key: "isActive",
      title: "Is Active",
      width: 100,
      Cell: (row: any) => {
        return (
          <SwitchToggle checked={row.rowData.isActive} onChange={() => { }}  data-attribute="CategoryManagement_Default_SwitchToggle" />
        );
      },
    },
  ];

  return (
    <>
      <div className="category-grid-container">
        <div className="app-area-header">
          <PrimaryButton
            text="Create New Category"
            className="pull-right"
            onClick={props.handleCreateModal}
           data-attribute="CategoryManagement_Default_Button" />
        </div>
        <div
          className={
            categoryListData?.data?.length !== 0
              ? "softura-table category-table"
              : "softura-table category-table paginationNav"
          }
        >
          <SofturaTable
            data={categoryListData?.data ?? []}
            columns={categoryColumns}
            sort={true}
            defaultPageSize={10}
            pageSizes={[10, 20, 50]}
            globalSearch={false}
            filter={true}
           data-attribute="CategoryManagement_Default_Grid" />
        </div>
      </div>
      {props.showCreateModal ? (
        <ModalPopup
          ShowModalPopupFooter={true}
          ModalPopupTitle={categoryById?.hasOwnProperty('id') ? "Edit Category" : "Create Category"}
          ModalPopupType="medium"
          FooterSecondaryBtnTxt="Cancel"
          FooterPrimaryBtnTxt="Save"
          closeModalPopup={props.handleCreateModal}
          PrimaryBtnOnclick={props.handleClickSave}
          SecondryBtnOnclick={props.handleCreateModal}
         data-attribute="CategoryManagement_Default_ModalPopup">
          <EditCategoryModal
            handleChange={props.handleChange}
            form={props.form}
            formError={props.formError}
            setForm={props.setForm}
          />
        </ModalPopup>
      ) : (
        ""
      )}
      {props.showDeleteModal ? (
        <ModalPopup
          ShowModalPopupFooter={true}
          ModalPopupTitle="Delete Category"
          ModalPopupType="medium"
          FooterSecondaryBtnTxt="No"
          FooterPrimaryBtnTxt="yes"
          closeModalPopup={props.handleDeleteModal}
          PrimaryBtnOnclick={props.handleDeleteClick}
          SecondryBtnOnclick={props.handleDeleteModal}
         data-attribute="CategoryManagement_Default_ModalPopup_2">
          <Label data-attribute="CategoryManagement_Default_Label">Are you sure you want to delete "{props.selectedName}"?</Label>
        </ModalPopup>
      ) : (
        ""
      )}
      <div className="categoryInfo-Modal">
      {props.showInfoModal ? (
        <ModalPopup
          ShowModalPopupFooter={true}
          ModalPopupTitle="Information"
          ModalPopupType="medium"
          FooterPrimaryBtnTxt="Ok"
          closeModalPopup={props.handleInfoModal}
          PrimaryBtnOnclick={props.handleInfoModal}
         data-attribute="CategoryManagement_Default_ModalPopup_3">
          <Label data-attribute="CategoryManagement_Default_Label_2">Successfully deleted "{props.selectedName}"</Label>
        </ModalPopup>
      ) : (
        ""
      )
      }
      </div>
      {addCategoryVal > 0 || checkCategory || addCategoryVal == "error" ? (
        <PopupDialogbox
          hideDialog={!props?.Popupcontent.isDialogVisible}
          onDismiss={() => props?.Popupcontent?.popupOutlinebtnOnclick()}
          Popupcontent={props?.Popupcontent}
          popupOutlinebtnOnclick={() => props?.Popupcontent?.popupOutlinebtnOnclick()}
          popupPrimarybtnOnclick={(
            item: any,
            actionby: string,
            value: any) => props?.Popupcontent?.popupPrimarybtnOnclick(item,
              actionby,
              value)}
         data-attribute="CategoryManagement_Default_PopupDilalogBox" />
      ) : null}
    </>
  );
};

export default CategoryManagement;
